<script>
  import { useData } from "$lib/state/data.svelte.js";
  import { GEO_LEVELS } from "$utils/consts.js";
  import { BasicDropdown, Button, logClickToGA } from "@urbaninstitute/dataviz-components";
  import { RadioGroup, RadioItem } from "$components/Radio/index.js";

  const data = useData();

  let levelData = [
    {
      value: GEO_LEVELS.STATE,
      label: data.labels.state_label
    },
    {
      value: GEO_LEVELS.DISTRICT,
      label: data.labels.district_label
    }
  ];

  let districtDropdownList = $derived(
    data.districtDropdownList.filter((district) => {
      let stateId = district.value.slice(0, 2);
      return stateId === data.currentState;
    })
  );

  let dollarList = [
    {
      value: "real",
      label: data.labels.real_dollar_label
    },
    {
      value: "nominal",
      label: data.labels.nominal_dollar_label
    }
  ];

  let districtDisabled = $derived(
    !data.currentChartData.some((layer) => layer.level === GEO_LEVELS.DISTRICT)
  );
</script>

<div class="sidebar-control-wrapper">
  <div class="control-item">
    <div class="control-label">Select a state:</div>
    <BasicDropdown
      bind:value={data.currentState}
      data={data.stateDropdownList}
      id="state-select"
      on:change={(e) => logClickToGA(e.currentTarget, "state-selected-sidebar")}
      dropdownWidth={200}
    />
  </div>
  <div class="control-item">
    <div class="control-label">Data level:</div>
    <RadioGroup
      bind:value={data.currentLevel}
      onValueChange={(e) => {
        logClickToGA(undefined, `geo-level-select-${e}`);
      }}
    >
      {#each levelData as { value, label }}
        {@const disabled = !data.levelMap.get(data.currentMetric).has(value)}
        <RadioItem {value} {label} {disabled}></RadioItem>
      {/each}
    </RadioGroup>
  </div>
  {#if data.currentLevel === "district" && !districtDisabled}
    <div class="control-item">
      <div class="control-label">Select a congressional district:</div>
      <BasicDropdown
        bind:value={data.currentDistrict}
        data={districtDropdownList}
        id="district-select"
        on:change={(e) => logClickToGA(e.currentTarget, "district-selected-sidebar")}
        dropdownWidth={200}
      />
    </div>
  {/if}
  {#if data.isCurrentMetricDollar}
    <div class="control-item">
      <div class="control-label">{data.labels.currency_control}</div>
      <RadioGroup bind:value={data.currentDollarType}>
        {#each dollarList as { value, label }}
          <RadioItem {value} {label}></RadioItem>
        {/each}
      </RadioGroup>
    </div>
  {/if}
</div>

<style>
  .control-item {
    margin-bottom: var(--spacing-8);
  }
  .control-label {
    font-weight: var(--font-weight-bold);
    font-family: var(--font-sans-alt);
    margin-bottom: var(--spacing-2);
    font-family: var(--font-family-sans-alt);
  }
  .sidebar-control-wrapper :global(button.radio-radio:focus:not(:focus-visible)) {
    outline: 0 !important;
  }
  .sidebar-control-wrapper :global(button.radio-radio:focus-visible) {
    outline: 2px solid var(--color-blue-shade-darker) !important;
    outline-offset: 2px !important;
  }

  .sidebar-control-wrapper :global(.dropdown-container select:focus:not(:focus-visible)) {
    outline: 0 !important;
  }
  .sidebar-control-wrapper :global(.dropdown-container select:focus-visible) {
    outline: 2px solid var(--color-blue-shade-darker) !important;
    outline-offset: 2px !important;
  }
  @media (min-width: 1024px) {
    .mobile-controls {
      display: none;
    }
  }
</style>
